const localStorage = {
    getItem: (key) => {
        try {
            return window.localStorage.getItem(key);
        } catch (err) { return null; }
    },
    setItem: (key, value) => {
        try {
            window.localStorage.setItem(key, value);
        } catch (err) {
            return null;
        }
    },
    removeItem: (key) => {
        try {
            window.localStorage.removeItem(key);
        } catch (err) { return null;}
    },
    clear: () => {
        try {
            window.localStorage.clear();
        } catch (err) {return null; }
    }
};

export default localStorage;
